import React from "react";

export function BKnightIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      height="1em"
      viewBox="0 0 123 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.2139 63.9858C70.5886 90.3185 26.7742 83.7108 27.6888 132.41L114.089 132.858C106.174 108.51 150.712 37.765 68.9953 10.9379C68.9953 10.9379 59.7804 1.10696 46.4485 0.265259L47.2902 13.6248L30.062 30.941C20.1241 42.8295 -2.95106 62.6074 0.765729 67.2665C12.542 87.3134 24.6924 84.0158 24.6924 84.0158C40.7244 66.8443 46.6859 76.1192 71.2139 63.9858Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.4882 114.79C70.4882 114.79 35.9777 114.972 26.3017 120.91C19.7733 124.917 18.2332 134.711 19.1214 144.811H121.857C122.745 134.711 121.205 124.917 114.676 120.91C105.001 114.972 70.4882 114.79 70.4882 114.79Z"
        fill={color}
      />
    </svg>
  );
}
